import { getPricingForFrequency } from '../../utility/comparator';

export default ngModule => {
    ngModule.controller('RootCtrl', function (
        AonApplicationService,
        AonConfig,
        OperatorService,
        smoothScroll,
        $scope,
        $state,
        $timeout,
        ZohoService,
        VERSION
    ) {
        this.version = VERSION.id;
        this.corporate = AonConfig.corporate;
        this.deployment = AonConfig.deployment;
        this.operator = AonConfig.operator;
        this.refine_pane_open = false;
        this.zohoApiError = ZohoService.apiError;

        // Track the last route, so that child controllers can access it
        $scope.lastRoute = null;
        $scope.$on('$stateChangeSuccess', (event, toState, ignore, fromState) => {
            $scope.lastRoute = fromState.url;
        });

        this.application = AonApplicationService.application;
        this.applicantHasActiveQuote = () => this.application && _.get(this.application, 'zoho.has_quote');

        // Map payment frequency string options to the key into PaymentFrequencies consts, and a display label
        const paymentFrequencyMap = {
            'weekly': ['Weekly', 'week'],
            'fortnightly': ['Fortnightly', 'fortnight'],
            'monthly': ['Monthly', 'month'],
            'quarterly': ['Quarterly', 'quarter'],
            'halfyearly': ['Half Yearly', 'half-year'],
            'yearly': ['Yearly', 'year'],
        };

        // Get the "per XXX" label for a payment frequency
        this.paymentFrequencyLabel = () => {
            return paymentFrequencyMap[OperatorService.filters.payment_frequency][1];
        };

        // When the operator filter payment frequency changes, update the application
        $scope.$watch(
            () => OperatorService.filters.payment_frequency,
            (newFreq, oldFreq) => {
                const paymentFrequency = AonConfig.jsConstants.PaymentFrequencies[paymentFrequencyMap[newFreq][0]];
                _.set(this.application, 'payment.frequency', paymentFrequency);
                AonApplicationService.saveApplication(this.application);
            });

        // When the operator filter discount code changes, and update the application
        $scope.$watch(
            () => OperatorService.filters.discount_code,
            (newCode) => {
                _.set(this.application, 'policy.discount_code', newCode);
                AonApplicationService.saveApplication(this.application);
            });

        this.getPricing = (pkg, which, directDebitDiscount, noDiscounts) => {
            const paymentFrequency = paymentFrequencyMap[OperatorService.filters.payment_frequency][0];
            return getPricingForFrequency(
                pkg,
                which,
                AonConfig.jsConstants.PaymentFrequencies[paymentFrequency],
                directDebitDiscount,
                noDiscounts
            );
        };

        this.currentPriceForDD = (pkg, applyDirectDebitDiscount) => {
            return this.getPricing(pkg, 'available', applyDirectDebitDiscount, false).premium;
        };

        this.currentPriceForRetention = (pkg) => {
            return this.getPricing(pkg, 'available', false, true).premium;
        };

        this.currentPrice = pkg => this.currentPriceForDD(pkg, pkg.apply_direct_debit_discount);

        this.currentPricing = (pkg) => {
            return this.getPricing(pkg, 'available', pkg.apply_direct_debit_discount, false);
        };

        this.futurePrice = (pkg) => {
            return this.getPricing(pkg, 'future', pkg.apply_direct_debit_discount, false).premium;
        };

        this.futurePriceDifference = (pkg) => {
            if (!pkg.selectedPrice.pricing.hasOwnProperty('available')) return null;
            let futurePrice = this.futurePrice(pkg);
            let currentPrice = this.currentPrice(pkg);
            return 100 * (futurePrice - currentPrice) / currentPrice;
        };

        /**
         * Scroll to the location of an element given by dom node id
         * @param id: String|[String] This can be an array of ids, or a single id
         * @param delay: delay in milliseconds before setting scroll position
         */
        this.scrollToId = (id, delay = 0) => {
            const ids = Array.isArray(id) ? id : [id];
            for (let _id of ids) {
                const matchingElements = window.angular.element(`#${_id}`);
                if (matchingElements.length) {
                    $timeout(() => {
                        smoothScroll(matchingElements[0], { stopOnUserScroll: true });
                    }, delay);
                    return;
                }
            }
        }

    });
}



// WEBPACK FOOTER //
// ./src/controllers/comparator/root-ctrl.js